import { EventEmitter } from "node:events";
import type {
  SilentCronXEventRecord,
  SilentCronXEventHandler,
  SilentCronXEventMap,
  SilentCronXEventName,
} from "../types/events.js";
import { nowIso } from "../utils/time.js";

export class EventBus {
  private readonly emitter = new EventEmitter();
  private readonly history: SilentCronXEventRecord[] = [];

  constructor(private readonly historyLimit = 100) {}

  on<TName extends SilentCronXEventName>(eventName: TName, handler: SilentCronXEventHandler<TName>): void {
    this.emitter.on(eventName, handler as (...args: unknown[]) => void);
  }

  off<TName extends SilentCronXEventName>(eventName: TName, handler: SilentCronXEventHandler<TName>): void {
    this.emitter.off(eventName, handler as (...args: unknown[]) => void);
  }

  emit<TName extends SilentCronXEventName>(eventName: TName, event: SilentCronXEventMap[TName]): void {
    this.record(eventName, event);
    this.emitter.emit(eventName, event);
  }

  getHistory<TName extends SilentCronXEventName>(eventName?: TName): SilentCronXEventRecord[] {
    return this.history.filter((record) => !eventName || record.eventName === eventName);
  }

  clearHistory(): void {
    this.history.length = 0;
  }

  private record<TName extends SilentCronXEventName>(eventName: TName, event: SilentCronXEventMap[TName]): void {
    if (this.historyLimit <= 0) return;
    this.history.push({ eventName, event, at: nowIso() } as SilentCronXEventRecord);
    while (this.history.length > this.historyLimit) this.history.shift();
  }
}
